import { Route, Switch } from "react-router-dom";

import About from "./pages/About";
import Landingpage from "./pages/Landingpage";
import Project from "./pages/Project";

const AppRouter = () => (
  <Switch>
    <Route path="/aboutme" component={About} />
    <Route path="/" exact component={Landingpage} />
    <Route path="/project/:projectname" component={Project} />
  </Switch>
);

export default AppRouter;
